<div class="next-event flex flex-column" *ngIf="nextEvent">
  <div class="teams flex" *ngIf="!nextEvent.isGroup; else eventIsShownOnHero">
    <div class="team-logo" *ngIf="nextEvent.team1Logo">
      <img [src]="'img/logo-klubova/'+nextEvent.team1Logo"/>
    </div>

    <div class="hero-separator flex flex-column" *ngIf="nextEvent.team2Name">
      <span class="hero-separator-text">VS</span>
    </div>

    <div class="team-logo" *ngIf="nextEvent.team2Logo">
      <img [src]="'img/logo-klubova/'+nextEvent.team2Logo"/>
    </div>
  </div>

  <ng-template #eventIsShownOnHero>
    <div class="group-ticket-img">
      <img [src]="'img/' + page + '/logo.png'"/>
    </div>
  </ng-template>

  <div
    class="next-event-content grid"
    [ngClass]="nextEvent.isGroup ? 'grid-2' : 'grid-3'">
    <div class="next-event-details">
      <p class="next-event-details-venue" *ngIf="!nextEvent.isGroup">{{ nextEvent.eventGroupName }} {{ nextEvent.comment1 }}</p>
      <p class="next-event-details-venue" *ngIf="nextEvent.isGroup">{{ nextEvent.eventName }}</p>
      <p class="next-event-details-info-text" *ngIf="nextEvent.startTime && !nextEvent.isGroup">{{ nextEvent.startTime | date:'dd.MM.yyyy - HH:mm':'Europe/Zagreb' }}</p>
      <p class="next-event-details-info-text" *ngIf="nextEvent.isGroup">{{ nextEvent.comment1 }}</p>
    </div>

    <div class="next-event-countdown" *ngIf="countDownTillEvent && !nextEvent.isGroup">
      <p class="countdown-text">
        <span>{{ "HERO.DAYS" | translate }}</span>
        <span>{{ "HERO.HOURS" | translate }}</span>
        <span>{{ "HERO.MINUTES" | translate }}</span>
      </p>
      <span class="countdown-number">{{ countDownTillEvent }}</span>
    </div>

    <div class="next-event-action text-center">
      <ng-container *ngFor="let action of nextEvent.actions">
        <button
          class="btn btn-secondary"
          *ngIf="(action.id === normalAction || action.id === subscriberAction) && action.membersExclusive"
          (click)="goToEventPage(nextEvent.connId, nextEvent.eventId, action.id, nextEvent)"
          >
            <ng-container *ngIf="currentOrderEventId === nextEvent.eventId; else eventIdDoesntMatch">
              {{ "COMMON.CONTINUE_SHOPPING" | translate }}
            </ng-container>
            <ng-template #eventIdDoesntMatch>
              {{ "HOMEPAGE.ONLY_FOR_CLUB_MEMBERS" | translate }}
            </ng-template>
        </button>

        <button
          class="btn btn-primary"
          (click)="goToEventPage(nextEvent.connId, nextEvent.eventId, action.id, nextEvent)"
          *ngIf="((action.id === normalAction || action.id === subscriberAction || action.id === seasonExclusiveAction) && !action.membersExclusive) || (action.id === seasonExclusiveAction && action.membersExclusive && !action.membersExclusive)"
          >
          <span *ngIf="!nextEvent.isGroup; else eventIsGroup">
            <ng-container *ngIf="currentOrderEventId === nextEvent.eventId; else eventIdDoesntMatch">
              {{ "COMMON.CONTINUE_SHOPPING" | translate }}
            </ng-container>
            <ng-template #eventIdDoesntMatch>
              {{ "COMMON.BUY_TICKET" | translate }}
            </ng-template>
          </span>

          <ng-template #eventIsGroup>
            <span *ngIf="nextEvent.isGroup">
              <ng-container *ngIf="currentOrderEventId === nextEvent.eventId; else eventIdDoesntMatch">
                {{ "COMMON.CONTINUE_SHOPPING" | translate }}
              </ng-container>
              <ng-template #eventIdDoesntMatch>
                {{ "COMMON.BUY_GROUP_TICKET" | translate }}
              </ng-template>
            </span>
          </ng-template>
        </button>
      </ng-container>
    </div>
  </div>
</div>
